import axios from 'axios';

const api_recomenda = axios.create({
  baseURL: process.env.REACT_APP_API_SW_RECOMENDA || 'http://localhost:3001/',
});

export default api_recomenda;
